module.exports = __webpack_public_path__ + "static/media/logo-dark.7beb4315.png";